import { render, staticRenderFns } from "./list.vue?vue&type=template&id=5b6a64ee&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"
import style0 from "./list.vue?vue&type=style&index=0&id=5b6a64ee&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6a64ee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b6a64ee')) {
      api.createRecord('5b6a64ee', component.options)
    } else {
      api.reload('5b6a64ee', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=5b6a64ee&scoped=true", function () {
      api.rerender('5b6a64ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/systemsettings/account/list.vue"
export default component.exports